export const images = {
    logoMega1: "../images/mega-logotipo1.png",
    logoMega2: "../images/mega-logotipo2.png",
    backgroundChangeToMovil: "../images/cambiate-movil-bg.jpg",
    downloadApp: "../images/descarga-la-app.png",
    appStore: "../images/descarga-en-app-store.png",
    googlePlay: "../images/disponible-google-play.png",
    loadingBlue: "../images/loading-blue.gif",
    megaLogo: "../images/mega-logotipo.png",
    secureTrust: "../images/secure-trust-logo.png",
    location: "../images/location.svg",
    loadingSpinnerGif: "../images/loading-spinner-84px.gif",
    iconError: "../images/icon-error.png",
    iconSuccess: "../images/icon-success.png",
    iconDique: "../images/icon-dique.png",
    iconCheckLevels: "../images/icon-skyline.png",
    iconIncognito: "../images/icon-incognito.png",
    iconWhatsAppSupport: "../images/soporte-whatsapp.png",
    iconMarker: "../images/marker.svg",
    tooltipSuscriptor: "../images/suscriptor.jpg",
    tooltipName: "../images/nombre.jpg",
    tooltipExtNum: "../images/numero-exterior.jpg",
    redesSociales: "../images/incluye-redes-sociales.svg",
    statementNotAvailable: "../images/edo-de-cuenta-no-disponible.webp",
    statementLoading: "../images/cargando-edo-de-cuenta.webp",
    welcomeSel: "../images/bienvenido-sel-mega.webp",
    welcomeSelBg: "../images/Mega-SEL-Login-Bg.jpg",
    logosSel: "../images/logotipos-sel.svg",
    megaSelImage: "../images/mega-en-linea.svg",
    megaLogoSel: "../images/mega-logotipo.svg",
    infoSel: "../images/sel-informacion.svg",
    bannerReferidos: "../images/referidos.jpg",
    megaLogoMR: "../images/mega-logo-mr.png",
    icon24g: '../images/icon-2-4-g.png',
    icon5g: '../images/icon-5g.png',
    loadingMegan: '../images/megan-loading-6.gif',
    alertMegamovil: '../images/lg_Mega-movil_H_blanco.png',
    megaModem: '../images/modem-mega.png',
    wifiOff: '../images/wiffi-off.png'
};